import {
  GET_USERS_TRANSACTIONS_FAILD,
  GET_USERS_TRANSACTIONS_LOADING,
  GET_USERS_TRANSACTIONS_SUCCESS,
  REMOVE_USERS_TRANSACTIONS
} from "../types";

const initialState = {
  transactions: null,
  loading: null,
  error: null,
};

export const getUsersTransactionsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_USERS_TRANSACTIONS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_USERS_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        transactions: action.payload,
      };
    case GET_USERS_TRANSACTIONS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case REMOVE_USERS_TRANSACTIONS:
      return initialState;
    default:
      return state;
  }
};
